import { Component, inject, AfterViewInit, OnDestroy } from "@angular/core";
import { ViewportScroller } from "@angular/common";
import { NavigationEnd, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { MatIconModule } from "@angular/material/icon";

@Component({
    standalone: true,
    selector: "app-terms-and-conditions",
    templateUrl: "./terms-and-conditions.component.html",
    styleUrls: ["./terms-and-conditions.component.scss"],
    imports: [MatIconModule]
})
export class TermsAndConditionsComponent implements AfterViewInit, OnDestroy {
    private router = inject(Router);
    private viewport = inject(ViewportScroller);
    private sub?: Subscription;

    ngAfterViewInit(): void {
        this.scrollToTop();
        setTimeout(() => this.scrollToTop(), 0);

        this.sub = this.router.events.subscribe(e => {
            if (e instanceof NavigationEnd) this.scrollToTop();
        });
    }

    private scrollToTop(): void {
        this.viewport.scrollToPosition([0, 0]);
        window.scrollTo({ top: 0, left: 0 });

        const host =
            document.querySelector<HTMLElement>('#scrollHost, .mat-drawer-content, .mat-sidenav-content, main, .content');
        host?.scrollTo({ top: 0, left: 0 });
    }

    goBack(): void {
        this.router.navigate(['/'], { fragment: 'footer-id' }).then(() => {
            const el = document.getElementById('footer-id');
            el?.scrollIntoView({ behavior: 'smooth' });
        });
    }

    ngOnDestroy(): void {
        this.sub?.unsubscribe();
    }
}
